// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDialog-VeloDialogTitle_cls1__s9RFj","cls2":"VeloDialog-VeloDialogTitle_cls2__Rd-ve VeloDialog-VeloDialogTitle_cls1__s9RFj"};